import { DocPage, Section, SpecTable } from "../../components/DocChrome";

export function MigrationPage() {
    return (
        <DocPage
            title="Migration & Deprecation"
            description="Move panels onto the canonical Hallmark modern-minimal system without big-bang rewrites."
        >
            <Section title="Completed migrations (@maeiz/ui & tokens)">
                <ul className="list-disc space-y-1 ps-5">
                    <li>
                        All four apps use <code>@maeiz/tokens</code>; gold <code>#C9A736</code>{" "}
                        canonical.
                    </li>
                    <li>Button/Card motion purged (zero playful micro-motion across all apps).</li>
                    <li>Radix DropdownMenu, Popover, Accordion, Combobox; Banner; DateField.</li>
                    <li>Rider/Customer fonts: Montserrat + Roboto + JetBrains Mono only.</li>
                    <li>
                        Elevated and unified in <code>@maeiz/ui</code>: <code>PageHeader</code>,{" "}
                        <code>StatCard</code>, <code>ActionMenu</code>, <code>ConfirmModal</code>,{" "}
                        <code>FormDialog</code>, <code>Pill</code>, <code>AuthShell</code>,{" "}
                        <code>PaginationBar</code>, <code>GlobalLoader</code>.
                    </li>
                    <li>
                        Hardcoded hex in CSS and JSX classes replaced with design token classes
                        across Rider, Customer, Tenant, and Owner.
                    </li>
                </ul>
            </Section>
            <Section title="Panel Alignment Status">
                <SpecTable
                    rows={[
                        [
                            "PageHeader",
                            "Canonical in @maeiz/ui; RTL arrow flip enabled; used across apps",
                        ],
                        [
                            "StatCard",
                            "Canonical in @maeiz/ui; used in Tenant, Owner, Rider, Customer",
                        ],
                        [
                            "Action menus & Popovers",
                            "Unified with @maeiz/ui ActionMenu & DropdownMenu",
                        ],
                        ["Modal dialogs", "Unified with @maeiz/ui ConfirmModal & FormDialog"],
                        [
                            "Buttons & Cards",
                            "Zero scale animation; unified @maeiz/ui variants across apps",
                        ],
                    ]}
                />
            </Section>
        </DocPage>
    );
}
